import { Flex, ActionIcon } from '@mantine/core';
import { IconArrowLeft, IconX } from '@tabler/icons-react';

type FlowHeaderProps = {
  onClose: () => void;
  onBack?: () => void;
  left?: React.ReactNode;
  middle?: React.ReactNode;
  right?: React.ReactNode;
};

export function FlowHeader({ onClose, onBack, left, middle, right }: FlowHeaderProps) {
  return (
    <Flex align="center" justify="space-between" px="md" pt="xxs" pb="lg">
      <Flex align="center">
        {onBack && (
          <ActionIcon variant="subtle" onClick={onBack} c="black" aria-label="Back" size={20}>
            <IconArrowLeft size={16} />
          </ActionIcon>
        )}
        {left}
      </Flex>

      <Flex align="center">{middle}</Flex>

      <Flex align="center" gap="xs">
        {right}
        <ActionIcon variant="subtle" onClick={onClose} c="black" aria-label="Close" size={20}>
          <IconX size={20} />
        </ActionIcon>
      </Flex>
    </Flex>
  );
}
